import React, { useState } from "react";
import KendoClientDetailTickets from "./KendoClientDetailTickets";
import { CLIENT_SEARCH_FILTERS } from "../../../constants/clientSearchFilters";

const ClientTicket = (props) => {
  const [Status, setStatus] = useState("O");
  const AlterStatus = (e) => {
    setStatus(e.target.value);
  };

  return (
    <div className="tab-pane" id="clientTask">
      <div role="tabpanel" className="tab-pane active" id="clientTask">
        <div className="table-panel task-table m-t-15">
          <div className="row table-panel-header">
            <div className="col-md-12 col-sm-12">
              <div className="row">
                <div className="col-md-9 col-sm-9">
                  <h6>Ticket Status</h6>
                </div>
                <div className="col-md-3 col-sm-3">
                  <div className="border-none field-container m-0 min-h-0">
                    <select
                      className="field-input mt-0"
                      name="note"
                      value={Status}
                      onChange={(e) => AlterStatus(e, "status")}
                    >
                      {CLIENT_SEARCH_FILTERS.CLIENT_TICKETS_STATUS.map(
                        (item) => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="table-panel-body" id="gridWidth">
            <KendoClientDetailTickets
              status={Status}
              type=""
              clientId={props.clientId}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientTicket;
